import { Typography, Statistic, Space } from 'antd'
import React, { useEffect, useMemo, useState } from 'react'
import type { CountdownProps } from 'antd'
import './index.scss'

const { Countdown } = Statistic

interface IOTPCountDownProps {
  isShowCountdown: boolean
  durationSeconds: number
  onFinishCallback?: Function
  hideCountDownHandler: Function
  toggleResetCountDown: boolean
}

export const OTPCountDown = (props: CountdownProps & IOTPCountDownProps) => {
  const [isShow, setIsShow] = useState(false)

  const {
    isShowCountdown,
    durationSeconds,
    onFinishCallback,
    title,
    toggleResetCountDown,
    hideCountDownHandler,
    ...rest
  } = props

  useEffect(() => {
    setIsShow(isShowCountdown)
    return () => {}
  }, [isShowCountdown])

  const deadline = useMemo(() => {
    return Date.now() + 1000 * durationSeconds
  }, [isShowCountdown, durationSeconds, toggleResetCountDown])

  const onFinish: CountdownProps['onFinish'] = () => {
    hideCountDownHandler()
    if (onFinishCallback) {
      onFinishCallback()
    }
  }

  return (
    <>
      {isShow ? (
        <Typography.Text className='count-down-section'>
          <Space className='count-down-otp'>
            <Countdown title={title ?? ''} format='mm:ss' value={deadline} onFinish={onFinish} {...rest} />
          </Space>
        </Typography.Text>
      ) : null}
    </>
  )
}
